import {SimpleReelModel} from "../../../core/reel/simplereel/SimpleReelModel";
import {HTHGameConfig} from "../../HTHGameConfig";
import {HTH} from "../../HTH";
import {gsap} from "gsap";
import {HTHSymbol} from "../../symbols/HTHSymbol";


export class EnhancerSpinArea extends PIXI.Container {

    public isEnhancerSpinning: boolean = false;
    public tlTime: number = 0;

    constructor() {
        super();
        this.position.set(120, 450);
        this.init();
    }

    private _reelModels: SimpleReelModel[];

    get reelModels(): SimpleReelModel[] {
        return this._reelModels;
    }

    public changeReelSet(): void {
        for (let i: number = 0; i < 5; i++) {
            this._reelModels[i].setReelSet(["L1", "M2", "L2", "M4", "L3", "M1", "M3", "L5", "L4", "M5"]);
        }
    }

    public startSpin(reelNo: number): gsap.core.Timeline {
        this.tlTime = 0;
        const startTL: gsap.core.Timeline = gsap.timeline();
        if (reelNo !== 0 && reelNo !== 5) {
            startTL.add(this._reelModels[reelNo - 1].start());
        }
        return startTL;
    }

    public stopSpin(reelNo: number, fillup: boolean = false, delayTime: number = 0.07): gsap.core.Timeline {
        let stopTL: gsap.core.Timeline = gsap.timeline();
        if (reelNo !== 0 && reelNo !== 5) {
            if (this._reelModels[JSON.parse(JSON.stringify(reelNo)) - 1].spinning) {
                this.isEnhancerSpinning = true;
                stopTL = gsap.timeline({delay: delayTime});
                stopTL.add(this._reelModels[JSON.parse(JSON.stringify(reelNo)) - 1].stop([HTH.model.gameData.enhancerBlocks[JSON.parse(JSON.stringify(reelNo)) - 1]]));
                this.tlTime = Math.max(stopTL.totalDuration() + delayTime, this.tlTime);
            }
        }
        return stopTL;
    }

    public changeSymbol(reelId: number, symName: string, size: number): void {
        this._reelModels[reelId - 1].changeSym(symName, size);
    }

    public hideSymbol(reelId: number): void {
        this._reelModels[reelId - 1].symbols.forEach((symData) => {
            (<HTHSymbol>symData.positionable).visible = false;
        })
    }


    private init() {
        const symbolMask = new PIXI.Graphics();
        symbolMask.beginFill(0xFFF678, 1);
        symbolMask.drawRect(-60, -74, HTHGameConfig.symbolWidth * 4, HTHGameConfig.symbolHeight);
        this.addChild(symbolMask);
        this.mask = symbolMask;

        this._reelModels = [];
        for (let i: number = 0; i < 4; i++) {
            const reel = new SimpleReelModel(i, true);
            reel.setReelSet(["L1", "M2", "L2", "M4", "L3", "M1", "M3", "L5", "L4", "M5"]);
            reel.stepSize = HTHGameConfig.symbolHeight;
            reel.init(["L1", "L2", "L3"]);

            this._reelModels.push(reel);
            this.addChild(reel.reelView);
        }

    }

}